import React, { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Nav from './components/Nav';
import Footer from './components/Footer';
import Projects from './pages/Projects';
import Professional from './pages/Professional';
import Carvings from './pages/Carvings';

// Don't let the browser restore the old scroll position on refresh; pages decide where to start
if ('scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

// Experience used to live at /professional; keep old links (and their ?role=) working
function RedirectToExperience() {
  const { search } = useLocation();
  return <Navigate to={{ pathname: '/', search }} replace />;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Header />
      <Nav />
      <main>
        <Routes>
          <Route path="/" element={<Professional />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/professional" element={<RedirectToExperience />} />
          <Route path="/woodworking" element={<Carvings />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
